import { render, staticRenderFns } from "./balance-record.vue?vue&type=template&id=0a021f18&scoped=true&"
import script from "./balance-record.vue?vue&type=script&lang=js&"
export * from "./balance-record.vue?vue&type=script&lang=js&"
import style0 from "./balance-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./balance-record.vue?vue&type=style&index=1&id=0a021f18&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a021f18",
  null
  
)

export default component.exports